module.exports = __webpack_public_path__ + "static/media/il-no-projects@2x.ac27d5c0.png";